import { render, staticRenderFns } from "./pre_date_week.vue?vue&type=template&id=631a297f&scoped=true"
import script from "./pre_date_week.vue?vue&type=script&lang=js"
export * from "./pre_date_week.vue?vue&type=script&lang=js"
import style0 from "./pre_date_week.vue?vue&type=style&index=0&id=631a297f&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a297f",
  null
  
)

export default component.exports